module.exports = __webpack_public_path__ + "img/accessory_hat_09.7a3df5c6.svg";